import * as RadioGroup from "@radix-ui/react-radio-group";
import styled from "styled-components";

export const RadioGroupRoot = styled(RadioGroup.Root)`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const RadioWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  label {
    margin: 0 4px;
    font-family: var(--font-secondary);
    font-weight: bold;
  }
`;

export const RadioGroupItem = styled(RadioGroup.Item)`
  background-color: #e2e2ea;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;

  :hover {
    background-image: linear-gradient(rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0.12));
  }
`;

export const RadioGroupIndicator = styled(RadioGroup.Indicator)`
  display: flex;
  justify-content: center;

  svg {
    width: 18px;
    height: 18px;
    padding: 4px;
    border-radius: 50%;
    background-color: #1d297c;
  }
`;
